var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCircleArrowDataTransferDiagonal(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 25,
    viewBox: "0 0 26 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.7426 8.3125L9.77956 13.5789C9.37508 14.0081 9.17285 14.2227 9.01218 14.159C8.85152 14.0953 8.86467 13.8058 8.89096 13.2267L8.97398 11.3992M11.2574 16.5625L16.2204 11.2961C16.6249 10.8669 16.8272 10.6523 16.9878 10.716C17.1485 10.7797 17.1353 11.0692 17.109 11.6483L17.026 13.4758",
    stroke: "#3B82F6",
    strokeWidth: 1.6875,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13 22.75C18.6954 22.75 23.3125 18.1329 23.3125 12.4375C23.3125 6.74206 18.6954 2.125 13 2.125C7.30456 2.125 2.6875 6.74206 2.6875 12.4375C2.6875 18.1329 7.30456 22.75 13 22.75Z",
    stroke: "#3B82F6",
    strokeWidth: 1.6875
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCircleArrowDataTransferDiagonal);
export default __webpack_public_path__ + "static/media/circle-arrow-data-transfer-diagonal.9c594b3db65f777db48df5040c6b7bb4.svg";
export { ForwardRef as ReactComponent };